import { Component } from '@angular/core';
import { NavigationService } from './core/services/navigation.service';
import { Router } from '@angular/router';

// parametro que vem do google
export const gclid = window.location?.href?.split('?')?.[1];

@Component({
  selector: 'app-root',
  template: `<div class="navigation {{ navigationService?.loading ? 'start' : 'end' }}">
      <div class="block"></div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <router-outlet></router-outlet>`
})
export class AppComponent {
  path: string;
  mensagem = 'Carregando...';
  constructor(public navigationService: NavigationService, private router: Router) {
    // redirecinoar link
    const qString = window.location.search;
    const qParams = new URLSearchParams(qString?.replace('#/', ''));
    const lcea = qParams?.get('lcea');

    const link = qParams?.get('votacao');

    if (link && link !== '') {
      this.router.navigate([`/votacao/${link}`]);
    } else if (lcea && lcea !== '') {
      this.router.navigate([`l/${lcea}`]);
    } else {
      const externalURL = window.location.hash;
      sessionStorage.setItem('redirect', externalURL.replace('#/', '/'));
      this.contornoGclid();
    }
  }

  contornoGclid(): void {
    if (gclid && window.location.href?.indexOf('/#/') < 0) {
      window.location.href = window.location.origin + `/#/?${gclid}`;
    }
  }
}
